import { useEffect, useState } from 'react';
import { api } from '@/lib/api';

const urlBase64ToUint8 = (b64) => {
  const padding = '='.repeat((4 - (b64.length % 4)) % 4);
  const base64 = (b64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  return new Uint8Array([...raw].map((c) => c.charCodeAt(0)));
};

export const usePushSubscription = (user) => {
  const [status, setStatus] = useState('idle'); // idle | granted | denied | subscribed | unsupported

  useEffect(() => {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      setStatus('unsupported'); return;
    }
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
    if (Notification.permission === 'granted') setStatus('granted');
    if (Notification.permission === 'denied') setStatus('denied');
  }, []);

  const subscribe = async () => {
    if (!user) return;
    try {
      const perm = await Notification.requestPermission();
      if (perm !== 'granted') { setStatus('denied'); return; }
      const reg = await navigator.serviceWorker.ready;
      const { data } = await api.get('/push/vapid');
      if (!data.public_key) { setStatus('granted'); return; }
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8(data.public_key),
      });
      const json = sub.toJSON();
      await api.post('/push/subscribe', { endpoint: json.endpoint, keys: json.keys });
      setStatus('subscribed');
    } catch (e) {
      console.warn('push subscribe failed', e);
    }
  };

  return { status, subscribe };
};
